import { callAppAPI } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { Facture, FacturePaymentInfos } from "src/domain/Facture";
import { callAppAPIByte } from "src/app/api/AppApiClientByte";
import { saveAs } from "file-saver";


export const getFactures = async () : Promise<Facture[]> => {
  return callAppAPI<Facture[]>({
    method: "GET",
    url: DictionnaireApi.getFactures.getUrl(),
  })
    .then(result => {
      return result;
    });
};

export const downloadFacture = (id: number) => {
  const url = DictionnaireApi.downloadFacture.getUrl(id);
  return callAppAPIByte<any>({
    method: "GET",
    url: url,
  }).then((result) => {
    const fileName = result.headers["content-disposition"].split('filename="')[1].slice(0, -1);
    saveAs(result.data, fileName);
  });
};

export const getPaymentLink = (factureId: number): Promise<FacturePaymentInfos> => {
  const url = DictionnaireApi.paymentLink.getUrl(factureId);
  return callAppAPI<FacturePaymentInfos>({
    method: "GET",
    url: url,
  })
  .then(result => {
    return result;
  });
}

export const updatePaymentStatus = (factureId: number): Promise<void> => {
  const url = DictionnaireApi.updatePaymentStatus.getUrl(factureId);
  return callAppAPI<void>({
    method: "POST",
    url: url,
  });
}
